"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = Nacebel;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function Nacebel(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    width: 100,
    height: 100
  }, props), /*#__PURE__*/_react["default"].createElement("g", {
    id: "General"
  }, /*#__PURE__*/_react["default"].createElement("g", {
    id: "nacebel"
  }, /*#__PURE__*/_react["default"].createElement("g", {
    id: "outline-4",
    "data-name": "outline"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M87.714,52.957h0l-16-16c-.023-.045-.036-.093-.062-.138L60.987,18.2a3.835,3.835,0,0,0-.976-1.115,6.856,6.856,0,0,0-3.147-1.868L29.344,7.741A6.92,6.92,0,0,0,20.862,12.6l-.587,2.161H18.037a6.919,6.919,0,0,0-6.911,6.911V50.189a6.861,6.861,0,0,0,1.013,3.589,3.834,3.834,0,0,0,.8,1.166L28.269,70.278c.011.02.016.041.027.06L39.469,89.846a3.974,3.974,0,0,0,5.418,1.47l2.81-1.61,1.632,1.632a3.974,3.974,0,0,0,5.615,0L68.482,77.8,85.1,68.284a3.975,3.975,0,0,0,1.472-5.419L85.423,60.86l2.291-2.29A3.976,3.976,0,0,0,87.714,52.957ZM56.47,20.618a2.411,2.411,0,0,0,.31.3l1.488,2.6L54.516,19.76l1.038.282A1.887,1.887,0,0,1,56.47,20.618ZM25.688,13.909a1.915,1.915,0,0,1,2.345-1.343L36.11,14.76H25.457ZM43.3,86.466l-1.558-2.719,2.3,2.3Zm8.843.609-35.5-35.5a2.455,2.455,0,0,0-.191-.339,1.884,1.884,0,0,1-.321-1.048V21.671a1.913,1.913,0,0,1,1.911-1.911H46.555a1.879,1.879,0,0,1,1.035.317,2.572,2.572,0,0,0,.376.2L83.449,55.763Z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M29.56,27.555a4.41,4.41,0,1,0,4.41,4.41A4.41,4.41,0,0,0,29.56,27.555Z"
  })))));
}